import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { VenueEditor } from "@/components/admin/VenueEditor";

export const Route = createFileRoute("/admin/venue")({
  component: VenuePage,
  head: () => ({
    meta: [
      { title: "Venue Details — Admin" },
      { name: "description", content: "Manage venue information and location" },
    ],
  }),
});

function VenuePage() {
  return (
    <AdminLayout>
      <VenueEditor />
    </AdminLayout>
  );
}
